import styled from "styled-components/macro";
import { THEME_COLOR } from "../../constant";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 100%;
`;

export const LayoutBorder = styled.div`
  width: 100%;

  height: 0.5rem;
  background-color: ${THEME_COLOR.PRIMARY};
`;

export const LayoutContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6rem;
`;

export const LayoutCenter = styled.div`
  width: 100%;
  max-width: 120rem;
`;
